var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5C0 6.50544 0.395088 5.55161 1.09835 4.84835C1.80161 4.14509 2.75544 3.75 3.75 3.75H26.25C27.2446 3.75 28.1984 4.14509 28.9016 4.84835C29.6049 5.55161 30 6.50544 30 7.5V16.875H0V7.5ZM21.5625 9.375C21.3139 9.375 21.0754 9.47377 20.8996 9.64959C20.7238 9.8254 20.625 10.0639 20.625 10.3125V12.1875C20.625 12.4361 20.7238 12.6746 20.8996 12.8504C21.0754 13.0262 21.3139 13.125 21.5625 13.125H25.3125C25.5611 13.125 25.7996 13.0262 25.9754 12.8504C26.1512 12.6746 26.25 12.4361 26.25 12.1875V10.3125C26.25 10.0639 26.1512 9.8254 25.9754 9.64959C25.7996 9.47377 25.5611 9.375 25.3125 9.375H21.5625ZM0 20.625V22.5C0 23.4946 0.395088 24.4484 1.09835 25.1516C1.80161 25.8549 2.75544 26.25 3.75 26.25H26.25C27.2446 26.25 28.1984 25.8549 28.9016 25.1516C29.6049 24.4484 30 23.4946 30 22.5V20.625H0Z",
    fill: "url(#paint0_linear_819_4250)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_819_4250",
    x1: 2,
    y1: 5,
    x2: 32,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33DA8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment-icon.15bce8ce.svg";
export { ForwardRef as ReactComponent };